import { render, staticRenderFns } from "./ProjectsHeader.vue?vue&type=template&id=a3d57c3c&"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports